import { gql } from "@apollo/client";

const UPDATE_TERM = gql`
  mutation setupTerm($input: UpdateTerm) {
    updateTerm(input: $input) {
      data
      status
      error
    }
  }
`;

export default UPDATE_TERM;
